import { EumApiCallOptions, EumApiDataMoldel, HttpMethods, EumApiConfig } from "./types";
import AxiosClient from "./AxiosClient";
export * from "./types";
import Vue from "vue";
import lsh from "@appbase/util/local-storage-helper";
class EumApiClient {
    private apiConfig: EumApiConfig;
    private axiosClient: AxiosClient;

    constructor(userConfig: EumApiConfig) {
        this.apiConfig = {
            // baseURL: baseUrl,
            timeout: userConfig.timeout,
            ...userConfig,
            requestConfig: {
                ...userConfig.requestConfig,
                headers: {
                    // Authorization: 'Bearer {token}',
                    "X-Requested-With": "XMLHttpRequest",
                    "X-EUM-TIMEZONE": this.getStandardTimezone(), //2022-06-19 타임존 정보를 헤더에 추가 함
                    "X-EUM-TIMEOFFSET": new Date().getTimezoneOffset(), //2022-06-19 타임존 정보를 헤더에 추가 함
                    ...userConfig.requestConfig?.headers,
                },
            },
        };
        this.axiosClient = new AxiosClient(this.apiConfig);

        (window as any).EumApiClient = this;
    }

    private getStandardTimezone() {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {
            let originDate = new Date().toLocaleDateString("en-us", {
                timeZoneName: "long",
                day: "numeric",
            });

            let strTimezone = originDate.split(",")[1].trim();

            return strTimezone != "" ? strTimezone : "";
        }
    }

    private send<T>(method: HttpMethods, option?: EumApiCallOptions): Promise<T> {
        var { url, data, params, headers } = option || {};
        var invalidatedUrl: string = this.invalidateUrl(url || "");

        const promise = this.axiosClient.send<EumApiDataMoldel<T>>(method, invalidatedUrl, data, params, headers);

        return promise.then<T>((data) => {
            if (data === undefined) {
                debugger;
            }

            if ((data as any).value) {
                return (data as any).value;
            }

            if (data && data.code === "ok") {
                return data.result;
            } else {
                throw (data || {}).error;
            }
        });
    }

    get<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.GET, option);
    }

    delete<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.DELETE, option);
    }

    put<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.PUT, option);
    }

    post<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.POST, option);
    }

    patch<T>(option?: EumApiCallOptions): Promise<T> {
        return this.send<T>(HttpMethods.PATCH, option);
    }

    async axiosFetch<T = any>(method: HttpMethods, option: EumApiCallOptions, onMessage: (data: T) => void): Promise<T> {
        var { url, fullurl, params, data, headers } = option || {};
        var invalidatedUrl: string = this.invalidateUrl(url || "");

        if (!url && fullurl) {
            invalidatedUrl = fullurl;
        }

        var finalHeaders: Record<string, string> = {
            Accept: "application/x-ndjson",
            ...(headers || {}),
            "X-Eum-Fatch": "true",
        };

        var httpMethod = "";

        switch (method) {
            case HttpMethods.POST:
                httpMethod = "POST";
                break;
            case HttpMethods.PATCH:
                httpMethod = "PATCH";
                break;
            case HttpMethods.DELETE:
                httpMethod = "DELETE";
                break;
            case HttpMethods.PUT:
                httpMethod = "PUT";
                break;
            default:
                httpMethod = "GET";
                break;
        }

        const response = await fetch(invalidatedUrl, {
            method: httpMethod,
            headers: finalHeaders,
        });

        const reader = response.body?.getReader();
        const decoder = new TextDecoder("utf-8");

        while (true) {
            var result = await reader!.read();
            const { done, value } = result;

            if (done) {
                break;
            }
            var buffer = decoder.decode(value, { stream: true });
            let rdata = JSON.parse(buffer);

            if (rdata) {
                if (rdata.code == "pending") {
                    // 진행중 리턴
                    onMessage(rdata.result);
                } else if (rdata.code == "ok") {
                    // 최종 리턴
                    return rdata.result;
                } else if (rdata.code == "error") {
                    console.log(rdata, "fetchError");
                    throw rdata?.result || rdata || {};
                    break;
                }
            }
        }
        return true as any;
    }

    async getFetch<T = any>(option: EumApiCallOptions, onMessage: (data: T) => void): Promise<T> {
        return await this.axiosFetch<T>(HttpMethods.GET, option, onMessage);
    }

    async deleteFetch<T = any>(option: EumApiCallOptions, onMessage: (data: T) => void): Promise<T> {
        return await this.axiosFetch<T>(HttpMethods.DELETE, option, onMessage);
    }

    async putFetch<T = any>(option: EumApiCallOptions, onMessage: (data: T) => void): Promise<T> {
        return await this.axiosFetch<T>(HttpMethods.PUT, option, onMessage);
    }

    async postFetch<T = any>(option: EumApiCallOptions, onMessage: (data: T) => void): Promise<T> {
        return await this.axiosFetch<T>(HttpMethods.POST, option, onMessage);
    }

    async patchFetch<T = any>(option: EumApiCallOptions, onMessage: (data: T) => void): Promise<T> {
        return await this.axiosFetch<T>(HttpMethods.PATCH, option, onMessage);
    }

    invalidateUrl(path: string): string {
        var rootUrl = this.apiConfig.rootUrl;
        var url = "";
        if (path.startsWith("/")) {
            url = rootUrl + path;
        } else if (path.startsWith("http://") || path.startsWith("https://")) {
            url = path;
        } else {
            url = path;
        }
        return url;
    }
}
export default EumApiClient;
